import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { CheckUserPayload, OtpRequiredResponse } from '@repo/user-types'

const initialState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: checkUserActions, reducer: checkUserReducer } = createOperationSlice<
  OtpRequiredResponse | null,
  SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
  CheckUserPayload
>({
  name: '@users/security/checkUser',
  initialState,
  reducers: {},
})
